import {UmpireImageMeta} from '@tisa-group/models/umpire';

export interface MediaLibraryFile {
  id: string;
  type: string;
  url: string;
  file_name: string;
  external_file_name: string;
  path: string;
  meta: UmpireImageMeta;
  external_url: string;
  created_at: string; // ISO-8601 date string
  client_id: string;
}
